import type { ShortTextParams } from '@repo/ui'
import type { StatusLabelType } from '@repo/ui'
import type { Readable, Writable } from 'svelte/store'

interface Params {
	[key: string]: any
	from?: number
	to?: number
}

export enum ColumnType {
	id = 'id',
	idLink = 'idLink',
	text = 'text',
	date = 'date',
	datetime = 'datetime',
	number = 'number',
	rate = 'rate',
	currency = 'currency',
	download = 'download',
	url = 'url',
	userAgent = 'userAgent',
	ipAddress = 'ipAddress',
	country = 'country',
	action = 'action',
	boolean = 'boolean',
	translate = 'translate',
}

export enum SortType {
	Asc,
	Desc,
}

interface Sorting {
	columnId: string
	direction: SortType
}

interface TooltipParams {
	text: string
}

export type ValueType =
	| string
	| number
	| boolean
	| { value: number; currencyCode: string }
	| null
	| undefined

export interface Column<T> {
	id?: string
	header: string
	value?: (row: T) => ValueType | Promise<ValueType>
	original?: Column<T>
	lastUpdated?: (row: T) => string
	link?: (row: T) => string
	icon?: string
	class?: string
	component?: any
	headerTooltip?: TooltipParams
	valueTooltip?: (row: T) => TooltipParams
	params?: (row: T) => Params
	type?: ColumnType
	summary?: (rows: Array<T>) => string | number | null | undefined
	status?: (row: T) => StatusLabelType
	statuses?: (row: T) => StatusLabelType[]
	shortText?: ShortTextParams
	disableSort?: boolean
	omitInDetail?: boolean
	copyButton?: boolean
	sum?: boolean
	allowFalsyInDetail?: boolean
	hidden?: boolean
}

export type Columns<T> = Column<T>[]

export type ColumnsStore<T> = Writable<Columns<T>>

export type Rows<T> = T[]

export type RowsStore<T> = Writable<Rows<T>>

export type SortStore = Writable<Sorting>

export type TotalStore = Readable<number>

type Url = (limit: number, offset: number) => string

export type UrlStore = Readable<Url>

type GoTo = (limit: number, offset: number) => void

export type GoToStore = Readable<GoTo>
